import React from "react";
import Modal from "react-bootstrap/Modal";
import { qformat, DATE_FORMATS, formatRelativeVerbose } from "views_shared/app/javascript/utils/dateFormatters";
import DiagnosticReport from "./DiagnosticReport";

function getProfileTypeLabel(profileType) {
  if (profileType === "Id::Profile::Promoter") return "Promoter";
  if (profileType === "Id::Profile::MediaProfile") return "Media";
  return "Unknown";
}

function getProfileTypeBadgeClass(profileType) {
  if (profileType === "Id::Profile::Promoter") return "bg-primary";
  if (profileType === "Id::Profile::MediaProfile") return "bg-info";
  return "bg-secondary";
}

/**
 * DiagnosticModal - Full-screen modal for complete diagnostic report
 *
 * Uses react-bootstrap Modal for proper handling.
 */
function DiagnosticModal({ diagnostics, isOpen, onClose }) {
  const userName = diagnostics ? `${diagnostics.first_name} ${diagnostics.last_name}` : "";
  const isEligible =
    diagnostics && (!diagnostics.ineligibility_reasons || diagnostics.ineligibility_reasons.length === 0);

  return (
    <Modal show={isOpen} onHide={onClose} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-stethoscope me-2" />
          Notification Diagnostic Report: {userName}
          {diagnostics && (
            <span className={`badge ${getProfileTypeBadgeClass(diagnostics.profile_type)} ms-2`}>
              {getProfileTypeLabel(diagnostics.profile_type)}
            </span>
          )}
          {diagnostics && (
            <span className={`badge ${isEligible ? "bg-success" : "bg-danger"} ms-2`}>
              {isEligible ? "Eligible" : "Not Eligible"}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {diagnostics ? (
          <DiagnosticReport user={diagnostics} />
        ) : (
          <div className="text-center text-muted py-4">No diagnostic data available.</div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div className="text-muted small">
          {diagnostics?.refreshed_at && (
            <>
              <i className="fa fa-clock-o me-1" />
              Data refreshed: {formatRelativeVerbose(diagnostics.refreshed_at)}
              <span className="ms-1">({qformat(diagnostics.refreshed_at, DATE_FORMATS.dateTime)})</span>
            </>
          )}
        </div>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DiagnosticModal;
